// extracted by mini-css-extract-plugin
module.exports = {"overlay":"style_overlay__1cdyJ","modal":"style_modal__3UU_Q"};